import getApiUrl from 'src/config/api';
import ApiError from 'src/utils/error';

const initializeRestaurant = async (slug, fingerprint, token) => {
    const additionalHeaders = token
        ? {
            'Authorization': `Bearer ${token}`
        }
        : {};

    return fetch(`${getApiUrl()}/api/client/clientSessions`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            ...additionalHeaders
        },
        body: JSON.stringify({
            clientFingerprint: fingerprint,
            restaurantName: slug
        })
    }).then((response) => {
        if (response.ok) {
            return response.json();
        } else {
            return response.json().then((json) => { throw new ApiError(json, response); });
        }
    });
};

const initializeCode = async (code, fingerprint) => fetch(`${getApiUrl()}/api/client/clientSessions`, {
    method: 'POST',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    },
    body: JSON.stringify({
        clientFingerprint: fingerprint,
        code
    })
}).then((response) => {
    if (response.ok) {
        return response.json();
    } else {
        return response.json().then((json) => { throw new ApiError(json, response); });
    }
});

export default {
    initializeRestaurant,
    initializeCode
};
